import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Create axios instance
const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000, // Aumentar timeout para 30 segundos
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Deve estar true para funcionar com CORS
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log detalhado de erros
    if (!error.response) {
      console.error('🚨 NETWORK ERROR:', {
        message: error.message,
        code: error.code,
        config: {
          url: error.config?.url,
          method: error.config?.method,
          baseURL: error.config?.baseURL
        }
      });
      
      // Retorna erro estruturado para erro de rede
      const networkError = new Error('Erro de conexão. Verifique sua internet ou se o servidor está rodando.');
      networkError.response = {
        data: {
          error: 'Erro de conexão com o servidor',
          message: 'Não foi possível conectar ao servidor. Verifique se o backend está rodando.'
        }
      };
      return Promise.reject(networkError);
    }
    
    // Log de erros HTTP
    console.error('❌ HTTP ERROR:', {
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url
    });
    
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('token');
      window.location.href = '/app/login';
    }
    
    return Promise.reject(error);
  }
);

export default api;